import './../css/kurs-button.css'
import React from 'react'

const KursButton = ({buttonName, onClick, btnIcon, backgroundColor = ""}) => {
    return (

            <div className="kleinbuttonsprimaer" onClick={onClick}>
                <div className="rechteck-grau rechteck-grau--breit">
                    <div className="kleinbuttontext-weiss">{buttonName}</div>
                </div>
                <div className="rechteck-rot" style={{backgroundColor: backgroundColor}}>
                    <div className="icon">{btnIcon}</div>
                </div>
            </div>
     
    )
}

export default KursButton

